import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
  LookupApiResponse,
  RegisterApiResponse,
  RequestOtpApiResponse,
  ValidateOtpApiResponse,
} from "../../../shared/models/api.response";
import {
  LookupDTO,
  RequestOtpViaMsisdnDTO,
  ValidateOtpDTO,
} from "../../../shared/models/dto.models";
import { PersonalDetails, RegistrationData } from "../registration.models";

export const registrationActions = createActionGroup({
  source: "registration",
  events: {
    "Canvasser Login": props<{ username: string }>(),
    "Terms Accepted": props<{
      termsStatus: boolean;
      marketingConsent: boolean;
    }>(),
    "Request Lookup": props<LookupDTO>(),
    "Request Lookup Success": props<LookupApiResponse>(),
    "Request Lookup Failed": props<LookupApiResponse>(),
    "Request Store Personal Details": props<PersonalDetails>(),
    "Request OTP Via Msisdn": props<RequestOtpViaMsisdnDTO>(),
    "Request OTP Via Msisdn Success": props<RequestOtpApiResponse>(),
    "Request OTP Via Msisdn Failed": props<RequestOtpApiResponse>(),
    "Request OTP Validation": props<ValidateOtpDTO>(),
    "Request OTP Validation Success": props<ValidateOtpApiResponse>(),
    "Request OTP Validation Failed": props<ValidateOtpApiResponse>(),
    "Request Registration": props<RegistrationData>(),
    "Request Registration Success": props<RegisterApiResponse>(),
    "Request Registration Failed": props<RegisterApiResponse>(),
    "Request Partial Reset": emptyProps(),
    "Request Full Reset": emptyProps(),
    "Request Reset Terms": emptyProps(),
    "Request Reset Intent": emptyProps(),
    "Request Reset OtpSent": emptyProps(),
    "Request Reset OtpMatch": emptyProps(),
  },
});
